import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/layout/marxzell__deko-element-faded-bg-mobile.svg")